/* @ngInject */
function CampaignWorkflowController ($rootScope, $scope, $q, $translate, $window, CampaignService, ToastService, UdsModalService, ModalService, TasksService, ConfirmationModalService, SegmentService) {
  const getNewTaskDialogController = () => $q.when(import('../../../workflow/dialogs/new-task/new-task-dialog.controller'))
  const getRequestFormDialogController = () => $q.when(import('../../../workflow/dialogs/request-form/request-form-dialog.controller'))
  const getBindCampaignDialogController = () => $q.when(import('../../../core/dialogs/bind-campaign/bind-campaign-dialog.controller'))
  const getArchivingConfirmationRequestController = () =>
    $q.when(import('../../../workflow/dialogs/archiving-confirmation-request/archiving-confirmation-request-dialog.controller'))
  const getCreateTaskDialogController = () => $q.when(import('../../../workflow/dialogs/create-task/create-task-dialog.controller'))
  const ARCHIVING_ALERT_NOT_SHOW_MESSAGE_KEY = 'workflow-archiving-alert-request-not-show-message-again'

  let activityCount = 0
  let currentSkip = 0

  $scope.tasks = []
  $scope.totalCount = 0
  $scope.archivingConfirmationRequestDialog = {
    dialog: null
  }

  const api = {
    getRequestFormDialogController,
    getNewTaskDialogController,
    getArchivingConfirmationRequestController,
    getCreateTaskDialogController,
    _openNewRequestDialog,
    _openCreateTask,
    _openNewTask,
    _openArchivingConfirmationAlert,
    _onConfirmArchivingConfirmationRequest,
    _handleArchiveWithSubtasks,
    _archiveTasks,
    _changeTaskFields,
    _changeTasksFieldsSuccess,
    _loadActivity,
    _bindTaskToCampaign,
    _unbindTaskFromCampaign,
    _openBindCampaignDialog
  }

  this.getApi = () => api

  $scope.options = [
    {
      text: $translate.instant('campaignsModule.dialogs.bindCampaign.headerTitleUnbind'),
      icon: 'target',
      onClick: api._openBindCampaignDialog
    }
  ]

  activate()

  function activate () {
    CampaignService.getCampaignTasks($scope.campaign.id)
      .then(tasks => {
        $scope.tasks = tasks
        $scope.totalCount = tasks.length
      })
      .catch(() => {
        ToastService.defaultErrorToast()
      })
  }

  const deregisterCampaignWorkflowReloadTasks = $rootScope.$on('campaign.reload-tasks', (e) => {
    activate()
  })

  const deregisterReopenCreateTaskDialog = $scope.$on('workflow.reopenCreateTaskDialog', (event, data) => {
    api._openCreateTask(data?.createMore)
  })

  $scope.$on('$destroy', () => {
    deregisterCampaignWorkflowReloadTasks()
    deregisterReopenCreateTaskDialog()
  })

  $scope.openCreateTask = api._openCreateTask

  function _openCreateTask (createMore = false) {
    if ($scope.campaign.status === 'FINISHED') return
    api.getCreateTaskDialogController().then(({ CreateTaskDialogController }) => {
      const modal = UdsModalService.createModal({
        controller: CreateTaskDialogController,
        modalName: 'createTaskDialogDirective',
        onClose: () => activate(),
        data: {
          campaignId: $scope.campaign.id,
          createMore
        }
      })

      modal.open()
    })
  }

  function _openNewRequestDialog (isRequestWithUser) {
    if ($scope.campaign.status === 'FINISHED') return
    api.getRequestFormDialogController().then(({ RequestFormDialogController }) => {
      ModalService.showModal({
        templateId: 'requestForm.html',
        templateUrl: '/workflow/dialogs/request-form/request-form-dialog.html?$$REVISION$$',
        controller: RequestFormDialogController,
        destroyable: true,
        observeChanges: true,
        data: {
          requestWithUser: isRequestWithUser,
          campaignId: $scope.campaign.id,
          location: 'campaign'
        }
      }).then(() => {
        activate()
      })
    })
  }

  function _openNewTask () {
    if ($scope.campaign.status === 'FINISHED') return
    api.getNewTaskDialogController().then(({ NewTaskDialogController }) => {
      ModalService.showModal({
        templateId: 'newTask.html',
        templateUrl: '/workflow/dialogs/new-task/new-task-dialog.html?$$REVISION$$',
        controller: NewTaskDialogController,
        destroyable: true,
        observeChanges: true,
        data: {
          currentCampaignId: $scope.campaign.id
        }
      }).then(() => {
        activate()
      })
    })
  }

  $scope.createButtons = [
    {
      icon: 'workflow',
      label: $translate.instant('requestForUser'),
      onClick: api._openNewRequestDialog.bind(this, true),
      disabled: $scope.campaign.status === 'FINISHED'
    },
    {
      icon: 'tasks',
      label: $translate.instant('task'),
      onClick: api._openNewTask,
      disabled: $scope.campaign.status === 'FINISHED'
    },
    {
      icon: 'clipboard',
      label: $translate.instant('taskWithForm'),
      onClick: api._openNewRequestDialog,
      disabled: $scope.campaign.status === 'FINISHED'
    }
  ]

  $scope.emptyState = {
    imgPath: 'campaign-workflow',
    title: $translate.instant('campaignEdit.workflow.emptyState.title'),
    message: $translate.instant('campaignEdit.workflow.emptyState.message'),
    button: {
      type: 'primary',
      icon: 'plus',
      text: $translate.instant('campaignEdit.workflow.emptyState.button'),
      click: () => api._openCreateTask(),
      options: $scope.createButtons,
      disabled: $scope.campaign.status === 'FINISHED',
      tooltip: {
        text: $translate.instant('campaignErrors.campaignFinished'),
        position: 'bottom',
        disabled: $scope.campaign.status !== 'FINISHED'
      }
    }
  }

  function _openBindCampaignDialog (taskId) {
    if ($scope.campaign.status === 'FINISHED') return
    getBindCampaignDialogController().then(({ BindCampaignDialogController }) => {
      const bindCampaignDialog = UdsModalService.createModal({
        controller: BindCampaignDialogController,
        modalName: 'bindCampaignDialog',
        data: {
          currentModule: 'requests',
          assetId: taskId,
          campaignId: $scope.campaign.id,
          campaignName: $scope.campaign.title
        },
        onClose: (bindDetails) => {
          if (bindDetails) {
            if (bindDetails.selectedCampaign) {
              api._bindTaskToCampaign(bindDetails)
            } else {
              api._unbindTaskFromCampaign(bindDetails)
            }
          }
        }
      })

      bindCampaignDialog.open()
    })
  }

  $scope.archiveTask = function (task) {
    const hasNotShowMessageValue = $window.localStorage.getItem(ARCHIVING_ALERT_NOT_SHOW_MESSAGE_KEY) === 'true'

    TasksService.getSubtasks(task.id).then((subtasks) => {
      const hasSubtasks = subtasks.length > 0

      if (hasSubtasks) {
        api._handleArchiveWithSubtasks(subtasks.length)
        return
      }

      if (hasNotShowMessageValue) {
        api._archiveTasks(task)
        return
      }

      api._openArchivingConfirmationAlert(task)
    })
  }

  function _handleArchiveWithSubtasks (subtaskCount) {
    ConfirmationModalService.createModal({
      title: $translate.instant('taskArchiveWarning.title'),
      description: $translate.instant('taskArchiveWarning.description', { count: subtaskCount }),
      buttonCancelText: $translate.instant('cancel'),
      buttonConfirmText: $translate.instant('confirm'),
      onConfirm: () => {
        api._archiveTasks()
      }
    })
  }

  function _archiveTasks (task, finallyCallback = () => {}) {
    api
      ._changeTaskFields(task, { isArchived: true })
      .then(api._changeTasksFieldsSuccess)
      .catch(ToastService.defaultErrorToast)
      .finally(finallyCallback)
  }

  function _changeTaskFields (task, params) {
    return TasksService.updateTaskFields(task.id, params).then(() => {
      if (params.isArchived !== undefined) {
        activate()
      } else {
        api._loadActivity(10, null, true)
      }
    })
  }

  function _changeTasksFieldsSuccess () {
    SegmentService.track('archived-task', { task_id: $scope.task.id, type: $scope.task.originType })
  }

  function _loadActivity (limit, offset, reset) {
    if (!$scope.task) {
      return
    }
    if (reset) {
      $scope.activities = []
      currentSkip = 0
    }

    $scope.showLoadMore = false

    TasksService.getTaskActivity($scope.task.id, limit, offset).then(activities => {
      activities.rows.forEach(activity => {
        $scope.activities.push(activity)
      })
      activityCount = activities.count
      $scope.showLoadMore = $scope.showLoadMore || currentSkip < activityCount
    })
    currentSkip = currentSkip + limit
  }

  function _openArchivingConfirmationAlert (task) {
    api.getArchivingConfirmationRequestController().then(({ ArchivingConfirmationRequestController }) => {
      $scope.archivingConfirmationRequestDialog.dialog = UdsModalService.createModal({
        controller: ArchivingConfirmationRequestController,
        modalName: 'archivingConfirmationRequestDialog',
        data: {
          loading: false,
          task: task,
          onConfirm: api._onConfirmArchivingConfirmationRequest
        }
      })

      $scope.archivingConfirmationRequestDialog.dialog.open()
    })
  }

  function _onConfirmArchivingConfirmationRequest (data, notShowMessageAgain) {
    data.loading = true

    if (notShowMessageAgain) {
      $window.localStorage.setItem(ARCHIVING_ALERT_NOT_SHOW_MESSAGE_KEY, true)
    }

    api._archiveTasks(data.task, () => {
      data.loading = false
      $scope.archivingConfirmationRequestDialog.dialog.close()
    })
  }

  function _bindTaskToCampaign (bindDetails) {
    TasksService.bindTaskToCampaign(bindDetails)
      .then(() => {
        ToastService.defaultSuccessToast()
        activate()
      })
      .catch(() => {
        ToastService.defaultErrorToast()
      })
  }

  function _unbindTaskFromCampaign (bindDetails) {
    TasksService.unbindTaskFromCampaign(bindDetails)
      .then(() => {
        ToastService.defaultSuccessToast()
        activate()
      })
      .catch(() => {
        ToastService.defaultErrorToast()
      })
  }
}

export { CampaignWorkflowController }
